<script>
import Select from './Select.vue';

export default {
    extends: Select,

    components: {
        Select,
    },

    props: {
        locales: Array,
        redirectUrlsJson: String,
        domains: Object,
        originalPlaceholderImageUrl: String,
        originalInputPlaceholderText: String,
    },

    data() {
        let redirectUrls = JSON.parse(this.redirectUrlsJson);
        return {
            options: [],
            selectedLocale: null,
            selectInputName: 'select-locale',
            redirectUrls: redirectUrls,
        };
    },

    computed: {
        inputPlaceholderText: function () {
            if (this.selectedLocale) {
                return this.optionLabel(this.selectedLocale);
            } else if (this.originalInputPlaceholderText) {
                return this.originalInputPlaceholderText;
            } else {
                return this.trans('common.choose_language');
            }
        },
        placeholderImageUrl: function () {
            if (this.selectedLocale !== null) {
                return this.optionImageUrl(this.selectedLocale);
            } else if (this.originalPlaceholderImageUrl) {
                return this.originalPlaceholderImageUrl;
            } else {
                return null;
            }
        },
    },

    mounted() {
        window.landingSelectLocale = this;
        this.hiddenInput = true;
        this.filterOptions();
    },

    watch: {
        opened(opened) {},

        selectedLocale(locale) {},

        selectInput(value) {
            this.filterOptions(value);
        },

        hiddenInput(isHidden) {},
    },

    methods: {
        optionImageUrl(locale) {
            return '/images/flags/' + locale + '.svg';
        },

        optionLabel(locale) {
            return locale != null
                ? this.trans('common.locations.language_info.' + locale)
                : '';
        },

        filterOptions(string) {
            string = string && string.trim();

            if (!string) {
                this.options = this.locales;
            } else {
                string = this.app.string.slugify(string);

                this.options = this.locales.filter((locale) => {
                    // Ignore special chars.
                    let label = this.app.string.slugify(
                        this.optionLabel(locale)
                    );

                    return !locale.id || label.indexOf(string) !== -1;
                });
            }
        },

        select(locale) {
            this.selectedLocale = locale;
            this.selectInputValue = this.optionLabel(locale);

            if (this.redirectUrls[locale] !== undefined) {
                this.hiddenInputValue = this.redirectUrls[locale];
            } else {
                this.hiddenInputValue = this.domains[locale];
            }

            Select.methods.select.call(this, locale);
        },
    },
};
</script>
